module.exports = __webpack_public_path__ + "img/pay1.8331815c.png";